import {
  LuShieldCheck,
  LuLock,
  LuUserCheck,
  LuDatabase,
  LuShield
} from "react-icons/lu"
import { useEffect, useState } from "react"
import "./WhyTrustUs.css"

function WhyTrustUs() {
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    setLoaded(true)
  }, [])

  return (
    <section id="why-trust-us" className={`trust-section ${loaded ? "loaded" : ""}`}>
      <div className="trust-header">
        <h2>
          <LuShield className="section-icon" /> Why Trust Us ?
        </h2><br />
        <div className="dashed-panel">
          <p className="trust-description">
            We focus on clarity, security and real-world alignment.
            Our system ensures that every student receives structured,
            reliable and safe career guidance.
          </p>
        </div>
      </div>

      <div className="trust-grid">

        <div className="trust-card">
          <LuShieldCheck className="trust-icon" style={{ color: '#3b82f6' }} />
          <h3>Verified Guidance</h3>
          <p>Roadmaps are structured, reviewed and aligned with real industry needs.</p>
        </div>

        <div className="trust-card">
          <LuLock className="trust-icon" style={{ color: '#22c55e' }} />
          <h3>Strong Security</h3>
          <p>Secure authentication and protected database systems keep your data safe.</p>
        </div>

        <div className="trust-card">
          <LuUserCheck className="trust-icon" style={{ color: '#8b5cf6' }} />
          <h3>Teacher & Admin Support</h3>
          <p>Direct support ensures genuine answers and career clarity.</p>
        </div>

        <div className="trust-card">
          <LuDatabase className="trust-icon" style={{ color: '#f97316' }} />
          <h3>Real-Time Updates</h3>
          <p>Content evolves with industry trends through our dynamic system.</p>
        </div>

      </div>
    </section>
  )
}

export default WhyTrustUs